module.exports = __webpack_public_path__ + "static/media/eye-not.b40f8d56.svg";